import React from 'react';

import { AuthContextProvider } from './auth';
import ListsProviders from './lists';

const AppProvider = ({ children }) => (
  <AuthContextProvider>
    <ListsProviders>
      {children}
    </ListsProviders>
  </AuthContextProvider>
);

export default AppProvider;
